/* global $ */

// If filters exist on page
if ($('.filters')) {
  // Invoke Selectric styles for <select> boxes
  $('.filters select').selectric();

  // Hide Submit button on filter areas
  $('.searchandfilter .sf-field-submit').hide();

  // Add fixed Type label to News Post filter
  $('.sf-field-category .selectric').prepend(
    '<span class="fixed-label">Type</span>',
  );

  // Add fixed Topic label to News Post filter
  $('.sf-field-taxonomy-insight-topic .selectric').prepend(
    '<span class="fixed-label">Topic</span>',
  );

  // Change selectric arrow to svgs
  $('.selectric .button').replaceWith(
    '<button class="selectric-button"><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.5 1.90244L11.472 -8.86466e-08L7 4.19512L2.528 -4.79601e-07L0.5 1.90244L7 8L13.5 1.90244Z"/></svg></button>',
  );

  // Use change function to submit filter areas
  $('.filters select').on('change', () => {
    $('.searchandfilter .sf-field-submit [type="submit"]').click();
  });

  $(
    '.filters [data-sf-field-input-type="checkbox"] li, .filters [data-sf-field-input-type="radio"] li',
  ).on('change', () => {
    $('.searchandfilter .sf-field-submit [type="submit"]').click();
  });
}
